import * as React from "react";
import { calculatePosition, getClientRect, movePositionWithinContainer } from "../../utils/tooltip";
import { IdTooltipAnchor } from "./IdTooltipAnchor";
import { TooltipModal } from "./TooltipModal";
import { TooltipTrigger } from "./TooltipTrigger";
export var DynamicTooltip = function (_a) {
    var component = _a.component, _b = _a.anchor, anchor = _b === void 0 ? IdTooltipAnchor.Bottom : _b, adjustHorizontal = _a.adjustHorizontal, adjustVertical = _a.adjustVertical, visibleOnClick = _a.visibleOnClick, children = _a.children, _c = _a.shouldRender, shouldRender = _c === void 0 ? true : _c, _d = _a.safe, safe = _d === void 0 ? false : _d;
    var originRef = React.createRef();
    var contentRef = React.createRef();
    var componentRef = React.createRef();
    return (React.createElement(TooltipTrigger, { visibleOnClick: visibleOnClick }, function (visible) {
        var pad = 10;
        var defaultPosition = { top: 0, left: 0, minWidth: 0, display: "none" };
        var tooltipStyle = contentRef && contentRef.current && originRef && originRef.current
            ? calculatePosition(pad, anchor, getClientRect(originRef), getClientRect(contentRef))
            : defaultPosition;
        var makeSafe = movePositionWithinContainer(window.innerWidth, window.innerHeight);
        if (safe) {
            makeSafe(tooltipStyle);
        }
        if (adjustHorizontal) {
            tooltipStyle.left += adjustHorizontal;
        }
        if (adjustVertical) {
            tooltipStyle.top += adjustVertical;
        }
        return (React.createElement("div", { ref: originRef },
            visible && shouldRender && (React.createElement(TooltipModal, null,
                React.createElement("div", { ref: componentRef, className: "tooltip__text tooltip__text--" + anchor + " tooltip__text--dynamic tooltip--visible", style: tooltipStyle }, component))),
            React.createElement("span", { ref: contentRef }, children)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tooltip/DynamicTooltip.tsx
// module id = 666
// module chunks = 3